
import { computed, defineComponent } from 'vue';
import { useStore } from 'vuex';
import { RawCourse, RawTimeSlot, CourseDetailInfo } from '../../types';
import { mapDay } from '../../utils';
import { NumberCardItem, InfoCardItem } from './components';

export default defineComponent({
  components: {
    NumberCardItem,
    InfoCardItem,
  },
  emits: ['delete-course'],
  setup(_, ctx) {
    const store = useStore();
    const course = computed<RawCourse>(() => store.state.detailPageCourse);

    const courseInfo = computed<CourseDetailInfo>(() => {
      // 处理为便于展示的形式
      const courseInfoCache: CourseDetailInfo = {
        codeId: course.value.code_id || '',
        name: course.value.name || '',
        credit: course.value.credit || 0,
        sectionCount: course.value.week_hour || 0,
        maxStudent: course.value.max_student || 0,
        department: course.value.department || '',
        campus: course.value.campus || '',
        remark: course.value.remark || '',
        examTime: course.value.exam_time || '',
        examType: course.value.exam_type || '',
        drop: course.value.drop ? '是' : '否',
        timeSlots: [],
        teachers: course.value.teachers || '',
      };
      if (course.value.time_slot) {
        course.value.time_slot.forEach((ts: RawTimeSlot) => {
          const {
            week, day, section, place,
          } = ts;
          const [sectionStart, sectionEnd] = section.split('-').map((i) => parseInt(i, 10));

          if (!courseInfoCache.sectionCount) {
            courseInfoCache.sectionCount += sectionEnd - sectionStart + 1;
          }
          courseInfoCache.timeSlots.push({
            week,
            day: mapDay(day), // 注意此处的对应关系，day 1 对应 周一，而非索引
            section: [sectionStart, sectionEnd], // 注意此处也是对应汉字的节数，而非索引
            place,
          });
        });
      }
      return courseInfoCache;
    });

    const handleClickDeleteButton = () => {
      store.commit('hideDetailDialog');
      ctx.emit('delete-course', course.value.id);
      store.commit('onDeleteDetailPageCourse');
    };

    const handleClickCloseButton = () => {
      store.commit('hideDetailDialog');
    };

    return {
      courseInfo,
      handleClickDeleteButton,
      handleClickCloseButton,
    };
  },
});
